/** @format */

import dayjs from "dayjs";
import "dayjs/locale/en";

export const formatDate = (rawDate, format = "ddd, D MMMM, HH:mm") => {
  if (rawDate) {
    const parsedDate = dayjs(rawDate);

    parsedDate.locale("en");

    const formattedDate = parsedDate.format(format);

    return formattedDate;
  } else {
    return "";
  }
};

export const formatDateWithoutTime = (rawDate) => {
  if (rawDate) {
    const parsedDate = dayjs(rawDate);

    parsedDate.locale("en");

    const formattedDate = parsedDate.format("ddd, D MMMM, YYYY");

    return formattedDate;
  } else {
    return "";
  }
};

export const checkDateValidity = (rawDate) => {
  const [day, month, year] = rawDate.split('/').map(Number);
  const inputDate = new Date(year, month - 1, day);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return today < inputDate;
}

export const getTimeElapsed = (timestamp) => {
  let targetTime;
  
  if (typeof timestamp === 'string') {
    targetTime = new Date(timestamp).getTime();
    if (isNaN(targetTime)) {
      return "Invalid timestamp format";
    }
  } 
  else if (typeof timestamp === 'number') {
    if (timestamp < 4102444800000) {
      targetTime = timestamp < 1000000000000 ? timestamp * 1000 : timestamp;
    } else {
      targetTime = timestamp;
    }
  }
  else if (timestamp instanceof Date) {
    targetTime = timestamp.getTime();
  }
  else {
    return "Invalid timestamp";
  }
  
  const now = Date.now();
  const diffMs = now - targetTime;
  
  if (diffMs < 0) {
    return "0 seconds";
  }
  
  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30.44); 
  const years = Math.floor(days / 365.25); 
  
  if (years > 0) {
    return `${years} ${years === 1 ? 'year' : 'years'}`;
  } else if (months > 0) {
    return `${months} ${months === 1 ? 'month' : 'months'}`;
  } else if (weeks > 0) {
    return `${weeks} ${weeks === 1 ? 'week' : 'weeks'}`;
  } else if (days > 0) {
    return `${days} ${days === 1 ? 'day' : 'days'}`;
  } else if (hours > 0) {
    return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
  } else if (minutes > 0) {
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
  } else {
    return `${seconds} ${seconds === 1 ? 'second' : 'seconds'}`;
  }
}